(function ($) {
  // in-page link
  const headerHight = 100;
  $("a[href^=#]").click(function () {
    const duration = 800;
    const href = $(this).attr("href");
    const target = $(href == "#" || href == "" ? "html" : href);
    const position = target.offset().top - headerHight;
    $("html, body").animate({ scrollTop: position }, duration, "swing");
    return false;
  });

  // scroll event
  const topBtn = $(".pagetop");
  topBtn.hide();
  $(window).scroll(function () {
    const scrollValue = 150;
    if ($(this).scrollTop() > scrollValue) {
      topBtn.fadeIn();
    } else {
      topBtn.fadeOut();
    }
  });

  // accordion element
  $(document).on("click", ".accordion__item_hdg", function () {
    $(this).parent().toggleClass("open");
    $(this).next().slideToggle();
    if ($(this).parent().hasClass("open")) {
      $(this).children(".accordion__item_toggle").html("－");
    } else {
      $(this).children(".accordion__item_toggle").html("+");
    }
  });
})(jQuery);
